/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TeamSearchInput_viewer = {
    readonly teamQueryResultErrorable: {
        readonly query?: string | undefined;
        readonly teams?: ReadonlyArray<{
            readonly teamName: string;
        }> | undefined;
    };
    readonly " $refType": "TeamSearchInput_viewer";
};
export type TeamSearchInput_viewer$data = TeamSearchInput_viewer;
export type TeamSearchInput_viewer$key = {
    readonly " $data"?: TeamSearchInput_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TeamSearchInput_viewer">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "orgRelayId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "query"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamSearchInput_viewer",
    "selections": [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "orgRelayId",
                    "variableName": "orgRelayId"
                },
                {
                    "kind": "Variable",
                    "name": "query",
                    "variableName": "query"
                }
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "teamQueryResultErrorable",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "query",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Team",
                            "kind": "LinkedField",
                            "name": "teams",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "teamName",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "type": "TeamQueryResult",
                    "abstractKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Viewer",
    "abstractKey": null
} as any;
(node as any).hash = '943b41da4accf986a108422d3408dacc';
export default node;
